export function Spinner({ label }: { label?: string }) {
  return (
    <div className="flex flex-col items-center gap-3 text-ink-muted">
      <div
        className="h-6 w-6 animate-spin rounded-full border-2 border-surface-border border-t-brand"
        role="status"
        aria-label={label ?? "加载中"}
      />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
}
